import { useRef, useState, useEffect } from 'react'

import cn from 'clsx'

import { REPORTS_TABS, ReportsTabs } from '../../../../model'

import s from './styles.module.scss'

export const Tabs = ({
  activeTab,
  setActiveTab,
}: {
  activeTab: ReportsTabs
  setActiveTab: (val: ReportsTabs) => void
}) => {
  const tabRef = useRef<HTMLDivElement>(null)
  const [selectorWidth, setSelectorWidth] = useState(0)
  const [selectorX, setSelectorX] = useState(0)

  useEffect(() => {
    if (tabRef.current) {
      const rect = tabRef.current.getBoundingClientRect()
      const parentRect = tabRef.current.parentElement!.getBoundingClientRect()

      setSelectorWidth(rect.width)
      setSelectorX(rect.left - parentRect.left - 4)
    }
  }, [activeTab])
  return (
    <div className={s.tabs}>
      {REPORTS_TABS.map((tab) => (
        <div
          key={tab.value}
          ref={activeTab === tab.value && s.active ? tabRef : null}
          className={cn(s.tab, activeTab === tab.value && s.active)}
          onClick={() => setActiveTab(tab.value)}
        >
          {tab.name}
        </div>
      ))}
      <span
        className={s.selector}
        style={{
          width: selectorWidth,
          transform: `translateX(${selectorX}px)`,
        }}
      />
    </div>
  )
}
